// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"c758dcd6","453":"505b96ff","967":"7b284a6b"}[chunkId] + ".chunk.js";
};